import React, { useEffect } from "react";
import Layout2 from "../../Layouts/Layout2";
import email from "../../assets/email.png";
import lock from "../../assets/lock.png";
import sideArrow from "../../assets/side-arrow.png";
import AlertsPopup from "../common/SettingPopup/SettingPopup";
import { useState } from "react";
import emailicon from "../../assets/emailicon.png";
import phone from "../../assets/phone.png";
import axiosInstance from "../../apiInstances/axiosInstance";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { IoEyeOutline } from "react-icons/io5";
import { FaChevronLeft, FaChevronRight, FaRegEyeSlash } from "react-icons/fa";
import { RiLockPasswordLine } from "react-icons/ri";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";

const AccountSetting = () => {
  const InputBox =
    "w-full text-xs md:text-sm rounded-lg border-[1px] border-[#949198] my-3 md:my-3 py-4 px-10 outline-none";

  const [AuthPopUp, setAuthPopUp] = useState();
  const [Email, setEmail] = useState();
  const [Iscale, setIscal] = useState(false);
  const [alertdata, setAlertdata] = useState({});
  const [datas, setData] = useState();
  const [popup, setPopup] = useState({ value: false, name: "" });
  //console.log("🚀 ~ AccountSetting ~ popup:", popup);
  const navigate = useNavigate();
  const [passHide, setPassHide] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });
  const [isPasswordError, setIsPasswordError] = useState(false);
  const [fields, setFields] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("email");
    setEmail(token);
  }, []);

  useEffect(() => {
    fields.newPassword == fields.confirmPassword
      ? setIsPasswordError(false)
      : setIsPasswordError(true);
    if (fields.confirmPassword.length == 0) {
      setIsPasswordError(false);
    }
  }, [fields.newPassword, fields.confirmPassword]);

  const onChangeInput = (e) => {
    const value = e.target.value.replace(/^\s+|\s+$/gm, "");
    const name = e.target.name;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const data = [
    {
      id: 0,
      maintitle: "Your property journey",
      content:
        "Recommended property information and tools based on your searches and activity.",
      email: emailicon,
      name: "Email",
      checkbox: "checkbox",
    },
    {
      id: 1,
      maintitle: "Saved search alerts",
      content: "Manage what alerts you get when you've saved a search.",
      email: emailicon,
      name: "Email",
      push: phone,
      name1: "push",
      con: "Download the app for push notifications",
      link: "Manage individual saved searches here",
      checkbox: "checkbox",
    },
    {
      id: 2,
      maintitle: "Property updates",
      content: "Notifications about properties you've shown interest in.",
      push: phone,
      name1: "push",
      con: "Download the app for push notifications",
    },
    {
      id: 3,
      maintitle: "Promoted residential properties",
      content:
        "Notifications about residential properties relevant to your search. ",
      email: emailicon,
      name: "Email",
      checkbox: "checkbox",
    },
    {
      id: 4,
      maintitle: "Promoted new developments",
      content:
        "Recommended new developments and property projects based on your searches and activity.",
      email: emailicon,
      name: "Email",
      checkbox: "checkbox",
    },
    {
      id: 5,
      maintitle: "Property updates",
      content:
        "Relates to the bell icon and notifications about your saved properties you've shown interest in.",
      checkbox: "checkbox",
      bordertop: "mt-6",
    },
    {
      id: 6,
      maintitle: "Market updates",
      content:
        "Market data, recent sales, auction results and updates on properties you like.",
      email: emailicon,
      name: "Email",
    },
    {
      id: 7,
      maintitle: "Sales and auction results",
      content: "Latest auction results and property sales.",
      push: phone,
      name1: "push",
      con: "Download the app for push notifications",
    },
    {
      id: 8,
      maintitle: "Property news and guides",
      content: "The latest property news, guides and inspiration.",
      email: emailicon,
      name: "Email",
    },
    {
      id: 9,
      maintitle: "Personalised ads",
      content:
        "Advertising tailored to you based on your activity and the information you've provided. If you opt out, you'll still get ads but they won't be tailored to you.",
      checkbox: "checkbox",
    },
    {
      id: 10,
      maintitle: "Suggested properties",
      content: "Property suggestions that match your activity and searches.",
      checkbox: "checkbox",
    },
  ];

  const sendEmail = async () => {
    localStorage.setItem("newEmail", datas);

    try {
      await axiosInstance
        .post("updateEmail", { email: datas, firstname: Email })
        .then((res) => {
          //console.log("res--------------------", res);
          if (res?.data?.status) {
            //console.log("hiiiiiiiiiiiiiii");
            toast.success("check your email");
            navigate("/VerifyOtp");
          } else if (res?.data?.page) {
            toast.success("check your email");
            navigate(`/${res?.data?.page}`);
          }
          setPopup(!popup);
        });
    } catch (e) {
      console.error(e);
    }
  };
  const sendPassword = async () => {
    if (fields.newPassword.length == 0) {
      return toast.error("Please enter password.");
    }
    if (fields.confirmPassword.length == 0) {
      return toast.error("Please enter confirm password.");
    }
    if (!isPasswordError) {
      try {
        await axiosInstanceAuth.post("updatePassword", fields).then((res) => {
          if (res?.data?.status) {
            toast.success(res.data.message);
            setAuthPopUp(false);
            setFields({
              currentPassword: "",
              newPassword: "",
              confirmPassword: "",
            });
            setPassHide({
              currentPassword: false,
              newPassword: false,
              confirmPassword: false,
            });
          } else {
            toast.error(res.data.message);
          }
        });
      } catch (e) {
        console.error(e);
      }
    }
  };
  const deleteAccount = async () => {
    try {
      await axiosInstance
        .post("deleteAccount", { email: Email })
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message);
            localStorage.clear();
            navigate(`/log-in`);
          }
          setPopup(!popup);
        });
    } catch (e) {
      console.error(e);
    }
  };
  const signoutAll = async () => {
    //console.log("hiiiiiiiiiiiiiiiii");
    try {
      await axiosInstance.get("signoutAll").then((res) => {
        //console.log("🚀 ~ awaitaxiosInstance.get ~ res:", res);
        if (res.data.status) {
          toast.success(res.data.message);
          localStorage.clear();
          navigate("/log-in");
        }
        setPopup(!popup);
      });
    } catch (e) {
      console.error(e);
    }
  };
  const onClose = async (e) => {
    setAuthPopUp(false);
    setFields({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
  };
  return (
    <>
      <div className="min-h-screen bg-[#F3F6F9] py-10 lg:py-14">
        <div className="container mx-auto px-3 lg:px-44">
          <button
            type="button"
            onClick={() => navigate("/dashboard")}
            className="inline-flex items-center gap-1.5 text-md font-medium text-[#097FE6] hover:text-[#0866c4] hover:underline shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-[#097FE6] focus-visible:ring-offset-2 rounded-md pb-5"
            aria-label="Back to dashboard"
          >
            <FaChevronLeft className="w-3.5 h-3.5 shrink-0" aria-hidden />
            Back to dashboard
          </button>
          <div className="flex items-center gap-3 mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-[#111827]">
              Settings
            </h1>
          </div>

          <div className="flex flex-col gap-8">
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-bold text-[#000929] mb-6">
                Account overview
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                <div className="flex flex-col">
                  <label className="text-sm text-[#000929] mb-2">Email</label>
                  <div className="flex gap-2">
                    <div className="flex-1 flex items-center justify-between gap-2 rounded-lg border border-[#D1D5DB] bg-[#F9FAFB] px-3 py-2.5">
                      <div className="flex items-center gap-2">
                        <img
                          src={email}
                          alt=""
                          className="w-4 h-4 shrink-0 text-[#9CA3AF]"
                        />
                        <span className="text-sm text-[#6B7280] truncate">
                          {Email || "josh@integrapaint.com.au"}
                        </span>
                      </div>
                      <button
                        type="button"
                        className="shrink-0 rounded-lg text-sm transition"
                        onClick={() => { }}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-[#000929] mb-2">
                    Password
                  </label>
                  <div className="flex gap-2">
                    <div className="flex-1 flex items-center justify-between gap-2 rounded-lg border border-[#D1D5DB] bg-[#F9FAFB] px-3 py-2.5">
                      <div className="flex items-center gap-2">
                        <img src={lock} alt="" className="w-4 h-4 shrink-0" />
                        <span className="text-sm text-[#6B7280]">
                          **********
                        </span>
                      </div>
                      <button
                        type="button"
                        className="shrink-0 rounded-lg text-sm transition"
                        onClick={() => setAuthPopUp(!AuthPopUp)}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-8">
                <h3 className="text-sm font-semibold text-[#000929]">
                  Sign out on all devices
                </h3>
                <p className="text-sm text-[#6B7280] mt-1">
                  Lost a device or recently used a public computer? Protect your
                  account by signing out on all devices.
                </p>
                <div className="flex justify-start mt-4">
                  <button
                    type="button"
                    className="rounded-lg border border-[#00092933]  text-[#000929] text-sm font-medium px-5 py-2.5 hover:bg-[#EAEAEA] transition"
                    onClick={() =>
                      setPopup({ value: !popup, name: "signoutall" })
                    }
                  >
                    Sign out on all devices
                  </button>
                </div>
              </div>
              <button
                type="button"
                className="mt-6 text-sm font-medium text-[#DC2626] hover:underline cursor-pointer"
                onClick={() =>
                  setPopup({ value: !popup, name: "deleteAccount" })
                }
              >
                Delete account
              </button>
            </section>

            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-bold text-[#000929] mb-6">
                Notification settings
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-[#000929] mb-2">
                    Property journey
                  </h3>
                  <div
                    onClick={() => {
                      setIscal(true);
                      setAlertdata(data[0]);
                    }}
                    className="flex justify-between items-center rounded-2xl border-2 border-[#EAEAEA] bg-white py-3 px-4 cursor-pointer hover:bg-[#F9FAFB] transition"
                  >
                    <div>
                      <div className="text-sm  text-[#111827]">
                        Your property journey
                      </div>
                      <div className="text-xs text-[#6B7280] mt-0.5">
                        On: Email
                      </div>
                    </div>
                    <FaChevronRight />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#000929] mb-2 mt-6">
                    Properties
                  </h3>
                  <div className="space-y-2">
                    {[
                      {
                        idx: 1,
                        title: "Saved search alerts",
                        status: "On: Email",
                      },
                      { idx: 2, title: "Property updates", status: "off" },
                      {
                        idx: 3,
                        title: "Promoted residential properties",
                        status: "On: Email",
                      },
                      {
                        idx: 4,
                        title: "Promoted new developments",
                        status: "On: Email",
                      },
                    ].map(({ idx, title, status }) => (
                      <div
                        key={idx}
                        onClick={() => {
                          setIscal(true);
                          setAlertdata(data[idx]);
                        }}
                        className="flex justify-between items-center rounded-2xl border-2 border-[#EAEAEA] bg-white py-3 px-4 cursor-pointer hover:bg-[#F9FAFB] transition"
                      >
                        <div>
                          <div className="text-sm  text-[#111827]">{title}</div>
                          <div className="text-xs text-[#6B7280] mt-0.5">
                            {status}
                          </div>
                        </div>
                        <FaChevronRight />
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#000929] mb-2 mt-6">
                    Property market
                  </h3>
                  <div className="space-y-2">
                    {[
                      { idx: 6, title: "Market updates", status: "On: Email" },
                      {
                        idx: 7,
                        title: "Sales and auction results",
                        status: "off",
                      },
                      {
                        idx: 8,
                        title: "Property news and guides",
                        status: "On: Email",
                      },
                    ].map(({ idx, title, status }) => (
                      <div
                        key={idx}
                        onClick={() => {
                          setIscal(true);
                          setAlertdata(data[idx]);
                        }}
                        className="flex justify-between items-center rounded-2xl border-2 border-[#EAEAEA] bg-white py-3 px-4 cursor-pointer hover:bg-[#F9FAFB] transition"
                      >
                        <div>
                          <div className="text-sm  text-[#111827]">{title}</div>
                          <div className="text-xs text-[#6B7280] mt-0.5">
                            {status}
                          </div>
                        </div>
                        <FaChevronRight />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <h2 className="text-lg font-bold text-[#000929] mb-6">
                Data privacy
              </h2>
              <div className="space-y-2">
                {[
                  { idx: 9, title: "Personalised advertising", status: "On" },
                  { idx: 10, title: "Suggested properties", status: "On" },
                  { idx: 5, title: "Property updates", status: "On" },
                ].map(({ idx, title, status }) => (
                  <div
                    key={idx}
                    onClick={() => {
                      setIscal(true);
                      setAlertdata(data[idx]);
                    }}
                    className="flex justify-between items-center rounded-2xl border-2 border-[#EAEAEA] bg-white py-3 px-4 cursor-pointer hover:bg-[#F9FAFB] transition"
                  >
                    <div>
                      <div className="text-sm  text-[#111827]">{title}</div>
                      <div className="text-xs text-[#6B7280] mt-0.5">
                        {status}
                      </div>
                    </div>
                    <FaChevronRight />
                  </div>
                ))}
              </div>
            </section>
          </div>
        </div>
      </div>

      <AlertsPopup setIsOpen={setIscal} IsOpen={Iscale} data={alertdata} />

      {AuthPopUp ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[999999]  outline-none focus:outline-none border ">
            <div className="relative min-w-[30%] mx-auto  my-10 shadow-black shadow-2xl">
              {/* ------ Content ------ */}
              <div className="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/* ------ Header ------ */}
                <div className="grid place-items-center place-content-end">
                  <button
                    className="bg-transparent border-0 text-black opacity-9 text-2xl font-normal outline-none focus:outline-none mx-3 my-2"
                    onClick={(e) => onClose(e)}
                  >
                    ×
                  </button>
                </div>
                {/* ------ Body ------ */}
                <div className="relative px-6 md:px-10 py-2 flex-auto ">
                  {/* <p className="text-start pb-2">Current Password:</p> */}
                  <div className="relative">
                    <input
                      type={!passHide.currentPassword ? "password" : "text"}
                      className={`${InputBox}`}
                      placeholder="Current Password"
                      name="currentPassword"
                      value={fields?.currentPassword}
                      onChange={(e) => onChangeInput(e)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          sendPassword();
                        }
                      }}
                    />
                    <RiLockPasswordLine className="text-[22px] text-[#6c6b71] absolute top-[30px] left-[10px]" />
                    {passHide.currentPassword ? (
                      <IoEyeOutline
                        onClick={() =>
                          setPassHide({ ...passHide, currentPassword: false })
                        }
                        className="text-[22px] text-[#6c6b71] absolute top-[30px] right-[15px] cursor-pointer"
                      />
                    ) : (
                      <FaRegEyeSlash
                        onClick={() =>
                          setPassHide({ ...passHide, currentPassword: true })
                        }
                        className="text-[22px] text-[#6c6b71] absolute top-[30px] right-[15px] cursor-pointer"
                      />
                    )}
                  </div>
                </div>
                <div className="relative px-6 md:px-10 py-2 flex-auto ">
                  {/* <p className="text-start pb-2">New Password:</p> */}
                  <div className="relative">
                    <input
                      type={!passHide.newPassword ? "password" : "text"}
                      className={`${InputBox}`}
                      placeholder="New Password"
                      name="newPassword"
                      value={fields?.newPassword}
                      onChange={(e) => onChangeInput(e)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          sendPassword();
                        }
                      }}
                    />
                    <RiLockPasswordLine className="text-[22px] text-[#6c6b71] absolute top-[30px] left-[10px]" />
                    {passHide.newPassword ? (
                      <IoEyeOutline
                        onClick={() =>
                          setPassHide({ ...passHide, newPassword: false })
                        }
                        className="text-[22px] text-[#6c6b71] absolute top-[30px] right-[15px] cursor-pointer"
                      />
                    ) : (
                      <FaRegEyeSlash
                        onClick={() =>
                          setPassHide({ ...passHide, newPassword: true })
                        }
                        className="text-[22px] text-[#6c6b71] absolute top-[30px] right-[15px] cursor-pointer"
                      />
                    )}
                  </div>
                </div>
                <div className="relative px-6 md:px-10 py-2 flex-auto ">
                  {/* <p className="text-start pb-2">Confirm Password:</p> */}
                  <div className="relative">
                    <input
                      type={!passHide.confirmPassword ? "password" : "text"}
                      className={`${InputBox}`}
                      placeholder="Confirm Password"
                      name="confirmPassword"
                      value={fields?.confirmPassword}
                      onChange={(e) => onChangeInput(e)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          sendPassword();
                        }
                      }}
                    />
                    <RiLockPasswordLine className="text-[22px] text-[#6c6b71] absolute top-[30px] left-[10px]" />
                    {passHide.confirmPassword ? (
                      <IoEyeOutline
                        onClick={() =>
                          setPassHide({ ...passHide, confirmPassword: false })
                        }
                        className="text-[22px] text-[#6c6b71] absolute top-[30px] right-[15px] cursor-pointer"
                      />
                    ) : (
                      <FaRegEyeSlash
                        onClick={() =>
                          setPassHide({ ...passHide, confirmPassword: true })
                        }
                        className="text-[22px] text-[#6c6b71] absolute top-[30px] right-[15px] cursor-pointer"
                      />
                    )}
                  </div>
                  <p className="text-red-600 text-xs">
                    {isPasswordError ? "Confirm password did't match." : ""}
                  </p>
                </div>

                {/* ------ Fotter ------ */}
                <div className="flex justify-center items-center m-5 mt-2">
                  {/* <button
                    className="border-2 border-[#525252] hover:border-black bg-white text-[#525252] font-semibold text-sm px-7 py-3 rounded-lg outline-none focus:outline-none ease-linear transition-all duration-150 mx-2"
                    // onClick={(e) => navigate("/sign-up")}
                  >
                    Join
                  </button> */}
                  <button
                    className="border-2 border-[#E5002A] bg-[#E5002A] hover:bg-[#db183c] text-white font-semibold text-sm px-7 py-3 rounded-lg outline-none focus:outline-none ease-linear transition-all duration-150 mx-2"
                    onClick={() => sendPassword()}
                  >
                    Change password
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-20 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
      {popup.name && (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[999999]  outline-none focus:outline-none border ">
            <div className="relative min-w-[250px] max-w-[90%] mx-auto  my-10 shadow-black shadow-2xl">
              {/* ------ Content ------ */}
              <div className="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/* ------ Header ------ */}
                <div className="grid place-items-center place-content-end">
                  <button
                    className="bg-transparent border-0 text-black opacity-9 text-2xl font-normal outline-none focus:outline-none mx-3 my-2"
                    onClick={(e) => setPopup(!popup)}
                  >
                    ×
                  </button>
                </div>
                {/* ------ Body ------ */}
                <div className="relative grid place-items-center px-6 md:px-10 py-3 flex-auto">
                  <h3 className="text-black font-semibold text-base md:text-lg  leading-relaxed text-center">
                    Are You Sure ?
                  </h3>
                  <p className="text-black mt-5 font-medium text-xs md:text-sm  leading-normal text-center">
                    {popup.name === "signoutall"
                      ? "You want to Sign out From All Devices?"
                      : "You want to Delete Account? "}
                  </p>
                </div>

                {/* ------ Fotter ------ */}
                <div className="flex justify-center items-center m-5">
                  <button
                    className="bg-[#18b66c] text-white font-semibold uppercase text-sm px-6 py-3 rounded-lg shadow hover:bg-[#1a965c] hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 mx-2"
                    type="button"
                    onClick={(e) =>
                      popup.name === "signoutall"
                        ? signoutAll()
                        : deleteAccount()
                    }
                  >
                    Yes
                  </button>
                  <button
                    className="bg-[#d31e1e] text-white font-semibold uppercase text-sm px-6 py-3 rounded-lg shadow hover:bg-[#cc1616] hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 mx-2"
                    type="button"
                    onClick={(e) => setPopup(!popup)}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-20 fixed inset-0 z-40 bg-black"></div>
        </>
      )}
    </>
  );
};

export default AccountSetting;
